<template>
  <div>
    <div id="page" data-swup="0" class="device-is-android">
      <header-bar :title="title"></header-bar>

      <footer-bar></footer-bar>
      <div
        class="page-content header-clear-medium has-footer-menu"
        style="transform: translateX(0px)"
      >
        <div class="pd-20 pb-b-0">
          <a
            @click="refreshData()"
            class="btn btn-3d btn-m btn-full rounded-xs text-uppercase font-900 shadow-s  border-blue-dark bg-blue-light"
          >
            Шинэчлэх</a
          >
          <div class="divider mb-3"></div>
        </div>
        <div class="card card-style mg-t-20">
          <div class="content mb-0">
            <div
              v-show="$store.state.app.activeForm.length > 0"
              class="bd-b pd-b-5 mg-b-5"
            >
              <div class="d-flex align-items-center">
                <span class="mg-b-0 tx-14">Санал асуулга</span>
                <button
                  class="btn btn-xs btn-warning text-white pd-y-2 pd-x-5 btn-uppercase mg-l-auto"
                  @click="
                    $router.push({
                      name: 'lmsSurvey',
                      params: {
                        id: $store.state.app.activeForm[0].id,
                        name: $store.state.app.activeForm[0].name,
                      },
                    })
                  "
                >
                  Санал асуулгад оролцох
                </button>
              </div>
            </div>

            <div
              :key="i"
              v-for="(f, i) in $store.state.app.activeForm"
              @click="
                $router.push({
                  name: 'lmsSurvey',
                  params: { id: f.id, name: f.name },
                })
              "
              class="alert alert-warning d-flex align-items-center"
              role="button"
            >
              <div class="pd-r-10">
                <feather class="wd-30-f ht-30-f" type="pie-chart"></feather>
              </div>
              <div>
                <div class="ivu-alert-message">{{ f.name }}</div>
                <hr class="mg-0-f" />
                <div class="ivu-alert-desc is-pointer">
                  {{ f.startDate | moment("YYYYоны MM.DD HH:mm") }} -
                  {{ f.endDate | moment("MM.DD HH:mm") }}
                </div>
              </div>
            </div>
            <!-- {{ $store.state.app.activeForm }} -->
            <div
              v-if="$store.state.app.activeForm.length == 0"
              class="text-center"
            >
              <span class=""> {{ $t("noSearchResults") }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="page-bg">
        <div></div>
      </div>

      <div class="divider divider-margins"></div>
    </div>
  </div>
</template>

<script>
//const moment = require("moment");
import moment from "moment";

import { request } from "@/api/all";
import { mapActions } from "vuex";
import footerBar from "@/views/apps/ubtzyouth/footerBar";
import headerBar from "@/views/apps/ubtzyouth/headerBar";

import "element-ui/lib/theme-chalk/index.css";
import { Carousel, CarouselItem } from "element-ui";

export default {
  components: {
    Carousel,
    CarouselItem,
    footerBar,
    headerBar,
  },
  data() {
    return {
      tasks: [],
      featuredTasks: [],
      title: "",
    };
  },
  created: function() {
    this.moment = moment;
  },
  methods: {
    ...mapActions(["handleDetailModal", "handleActiveForm"]),
    init() {},
    refreshData(){
      request({
            api: { method: "get", url: "Form/GetFutureSharedFormList" },
            store: this.$store,
          }).then((res) => {
            if (res != false) {
              if (res.data.list.length > 0) {
                this.handleActiveForm(res.data.list);
              }
            }
          });
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.id != oldRoute.params.id) {
        this.init();
      }
    },
  },
};
</script>
<style scoped></style>
